// extracted by mini-css-extract-plugin
export default {"refreshStyle":"UnitStatsTable_refreshStyle__J86AM","spinRefresh":"UnitStatsTable_spinRefresh__oFIqK","refreshStyleLoading":"UnitStatsTable_refreshStyleLoading__VjFee"};